import {FC} from 'react';
import {FiHeart} from 'react-icons/fi';
import {FaHeart} from 'react-icons/fa';

type UIHeartProps = {
  id?: number;
  saveFavorite: Function;
  favoritesHeart?: boolean;
  isFavorite?: boolean;
}

const UIHeart: FC<UIHeartProps> = ({saveFavorite, id, favoritesHeart, isFavorite}) => {
  if (favoritesHeart || isFavorite) {
    return (
      <FaHeart
        className='text-red-500 text-base'
        onClick={() => saveFavorite(id)}
      />
    );
  }
  return (
    <FiHeart
      className='text-gray-colorsBorder text-base'
      onClick={() => saveFavorite(id)}
    />
  );
};

export default UIHeart;
